<template>
    <!-- <v-row>
        <v-col>
            <v-card 
                class="elevation-0 rounded-xl" 
                :loading="load_devices"
                style="height: 100vh;" 
                > 
                <v-card-title>
                    <h2>دما ها :</h2>
                </v-card-title>
                <v-card-text class="ma-5" v-if="devices.temps.length>0">
                    <v-btn 
                        class="ma-5 elevation-0 primary"
                        large 
                        v-for="device in devices.temps"
                        >
                        {{ device }}
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col>
            <v-card 
                v-if="devices.relays.length>0"
                class="elevation-0 rounded-xl"
                style="height: 100vh;" 
                :loading="load_devices"
            > 
                <v-card-title>
                    <h2>رله ها :</h2>
                </v-card-title>
                <v-card-text class="ma-5">
                        <v-btn 
                            class="ma-5 elevation-0"
                            v-for="device in devices.relays"
                            >
                            {{ device }}
                        </v-btn>
                </v-card-text>
            </v-card>
        </v-col>
    
   
    </v-row> -->

    <!-- <div>
        <v-card class="elevation-0 rounded-xl" v-if="!detail.en" :loading="loading">
            <v-tabs v-model="tab" fixed-tabs bg-color="indigo-darken-2">
                <v-tab :value="1">
                دما ها
                </v-tab>
                <v-tab :value="2">
                وضعیت رله ها
                </v-tab>
                <v-tab :value="3">
                رطوبت ها
                </v-tab>
                <v-tab :value="4">
                ولتاژ ها
                </v-tab>
            </v-tabs>
            <v-window v-model="tab">
                <v-window-item>
                    <v-container class="text-center">
                        <v-btn 
                            large outlined color="red"
                            class="ma-5 elevation-1" 
                            v-for="device in devices.temps"
                            @click="show_detail(name=device, view='temp')"
                        >
                            {{ device }}
                        </v-btn>
                    </v-container>
                </v-window-item>
                <v-window-item>
                    <v-container class="text-center">
                        <v-btn 
                            large outlined color="red"
                            class="ma-5 elevation-1" 
                            v-for="device in devices.relays"
                            @click="show_detail(name=device, view='relay')"
                        >
                            {{ device }}
                        </v-btn>
                    </v-container>
                </v-window-item>
                <v-window-item>
                    <v-container class="text-center">
                        <v-btn 
                            large outlined color="red"
                            class="ma-5 elevation-1" 
                            v-for="device in devices.humidities"
                            @click="show_detail(name=device, view='hum')"
                        >
                            {{ device }}
                        </v-btn>
                    </v-container>
                </v-window-item>
                <v-window-item>
                    <v-container class="text-center">
                        <v-btn 
                            large outlined color="red"
                            class="ma-5 elevation-1" 
                            v-for="device in devices.voltages"
                            @click="show_detail(name=device, view='volt')"
                        >
                            {{ device }}
                        </v-btn>
                    </v-container>
                </v-window-item>
            </v-window>
        </v-card>
        <div v-else>
            <DevicesDataTemp 
                v-if="detail.view === 'temp'"
                :detail="detail"
                :chartData="chartData"
                />
            <DevicesDataRelay 
                v-else-if="detail.view === 'realy'"
                :chartData="chartData"
                :detail="detail"
                />
            <DevicesDataHum
                v-else-if="detail.view === 'hum'"
                :chartData="chartData"
                :detail="detail"
            />
            <DevicesDataVolt
                v-else
                :chartData="chartData"
                :detail="detail"
            />
        </div>
    </div> -->
    <div>
        <BordsList />
    </div>

</template>
<script>
import BordsList from './devices_data/boards.vue'
import axios from "axios"
export default {
    name: "HomeDevicesData",
    components: {
        BordsList
    },
    data: () => ({
        key: localStorage.getItem('key'),
        tab: null,
        loading:true,
        detail:{
            en:false,
            name:null,
            view:"temp",
            data:[],
        },
        chartData : {
            labels:[],
            datasets:[{
                label:"",
                backgroundColor: '#D20003',
                data:[]
            }]
        },
        devices: {
            temps: [],
            relays: [],
        },

            
    }),
    created() {
    },
    methods: {
        show_detail(name, view){
            this.loading = true;
            axios
                .get(`${this.BACKEND_LINK}/api/devices-data/detail/?field_name=${name}`, {
                    headers: { 'Authorization': `Token ${this.key}` }
                })
                .then(response => {
                    this.detail={
                        en:true,
                        name:name,
                        view:view,
                        data:response.data
                    }
                    if (view === "temp"){
                        this.chartData.datasets[0].label="دما"
                    }
                    else if (view === "relay"){
                        this.chartData.datasets[0].label="وضعیت رله"
                    }
                    else if (view === "hum"){
                        this.chartData.datasets[0].label="رطوبت"
                    }
                    else {
                        this.chartData.datasets[0].label = "ولت"
                    }
                    for(let i=0;i < response.data.length;i++){
                            this.chartData.labels.push(
                                new Date(response.data[i]['_time']).toLocaleString("fa-ir").split(',')[1]
                            );
                            this.chartData.datasets[0].data.push(response.data[i]['_value']);
                    }
                    this.loading = false;
                })
                .catch((errors) => {
                    this.loading = false;
                    this.$snotify.error('خطا در دریافت اطلاعات', `کد ${errors.response.code}‍‍‍`)
                })
        },
        get_devices() {
            this.loading = true;
            axios
                .get(`${this.BACKEND_LINK}/api/devices-data/`, {
                    headers: { 'Authorization': `Token ${this.key}` }
                })
                .then(response => {
                    this.devices = response.data;
                    this.loading = false;
                })
                .catch((errors) => {
                    this.loading = false;
                    this.$snotify.error('خطا در دریافت اطلاعات', `کد ${errors.response.code}‍‍‍`)
                })
        },
    }
}
</script>
